var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "a1defb77de48b16c20776048c5fbeef3.png",
    width: 312,
    height: 600
});